import React, { useMemo } from "react";

import { EntityType } from "@mapmycustomers/shared/enum";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import { StandardFilterButton } from "@app/component/filtering";
import activityFieldModel from "@app/util/fieldModel/ActivityFieldModel";

import ActivitiesSearch from "./ActivitiesSearch";
import styles from "./Toolbar.module.scss";

interface Props {}

const Toolbar: React.FC<Props> = () => {
  const hiddenFilterFields = useMemo(
    () =>
      [
        activityFieldModel.getByName("startAt"),
        activityFieldModel.getByName("completed"),
        ...activityFieldModel.fields.filter((field) =>
          field.hasFeature(FieldFeature.NON_LIST_VIEW)
        ),
      ].filter(isDefined),
    []
  );

  const hiddenSavedFilterFields = useMemo(
    () => [activityFieldModel.getByName("startAt")].filter(isDefined),
    []
  );

  return (
    <div className={styles.container}>
      <ActivitiesSearch className={styles.search} />
      <StandardFilterButton
        context="activityPage"
        entityType={EntityType.ACTIVITY}
        hiddenFields={hiddenFilterFields}
        implicitFilterFields={hiddenSavedFilterFields}
      />
    </div>
  );
};

export default Toolbar;
